// Everything not listed here defaults to false — see systems/contract.js.
const capabilities = {
  levelProgression: true,
  rests:            true,
  spellSlots:       true,
  exhaustion:       true,
  armorAC:          true,
  encumbrance:      true,
  deathSaves:       true,
  homebrew:         true,
};

export default capabilities;
